import { render, staticRenderFns } from "./KaitakSubForm.vue?vue&type=template&id=296ca428&scoped=true"
import script from "./KaitakSubForm.vue?vue&type=script&lang=js"
export * from "./KaitakSubForm.vue?vue&type=script&lang=js"
import style0 from "./KaitakSubForm.vue?vue&type=style&index=0&id=296ca428&prod&lang=scss"
import style1 from "./KaitakSubForm.vue?vue&type=style&index=1&id=296ca428&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296ca428",
  null
  
)

export default component.exports